var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.97081 8.99922L14.8927 3.13234C14.9752 3.03484 14.9058 2.88672 14.7783 2.88672H13.2821C13.1939 2.88672 13.1096 2.92609 13.0514 2.99359L8.99206 7.83297L4.93269 2.99359C4.87644 2.92609 4.79206 2.88672 4.70206 2.88672H3.20581C3.07831 2.88672 3.00894 3.03484 3.09144 3.13234L8.01331 8.99922L3.09144 14.8661C3.07296 14.8878 3.0611 14.9144 3.05728 14.9427C3.05345 14.9709 3.05782 14.9997 3.06986 15.0256C3.08191 15.0514 3.10112 15.0733 3.12522 15.0886C3.14931 15.1038 3.17729 15.1119 3.20581 15.1117H4.70206C4.79019 15.1117 4.87456 15.0723 4.93269 15.0048L8.99206 10.1655L13.0514 15.0048C13.1077 15.0723 13.1921 15.1117 13.2821 15.1117H14.7783C14.9058 15.1117 14.9752 14.9636 14.8927 14.8661L9.97081 8.99922Z",
    fill: "black",
    fillOpacity: 0.85
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.539c8f8f.svg";
export { ForwardRef as ReactComponent };